
export const countryFlagsUrls = [
  {
    country: 'default',
    url: '../../assets/img/circle.png'
  }       
];
